<script lang="ts">
const __DsBlock = {
	name: '$t:blocks.table.name',
	icon: 'lucide:table',
	category: 'layout',
	type: 'listing-layout',
	hidden: true,
	events: [
		{
			name: 'open',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
		{
			name: 'update:displayOptions',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
	],
	slots: ['actions'],
}
</script>
<script lang="ts" setup generic="T extends TableData">
import type { TableData } from '@nuxt/ui';
import type { CompositePrimaryKey } from '#layers/data-model';
import type { LayoutTableProps, TableDisplayOptions } from '~/components/Layout/Table/LayoutTable.vue';
import type { SharedLayoutEmits, SharedLayoutProps } from '~/types/layout';
import { defineBlock } from '#layers/block-engine';

interface LayoutTableBlockProps extends SharedLayoutProps<TableDisplayOptions> {
	canSelect?: LayoutTableProps<T>['canSelect'];
	spacing?: LayoutTableProps<T>['spacing'];
}

defineProps<LayoutTableBlockProps>();

defineEmits<Pick<SharedLayoutEmits, 'open' | 'update:displayOptions'>>();

const selection = defineModel<CompositePrimaryKey[]>('selection', { default: () => [] });

;
</script>

<template>
	<LayoutTable
		v-bind="$props"
		v-model:selection="selection"
		@open="$emit('open', $event)"
		@update:display-options="$emit('update:displayOptions', $event)"
	/>
</template>
